import React, { Fragment } from "react"
import contains from "underscore/modules/contains"
import reject from "underscore/modules/reject"

import ServiceRow from "../ServiceRow"
import { ALL_CATEGORIES } from "../VenueServicesList"

import style from "./ServicesSectionsPreview.module.scss"

// ----------------------------------------------------------------------------

function ServicesSectionsPreview(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { sectionsPreview, sections, onServiceClick, handleShowAll } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function renderSectionPreview(sectionPreview) {
    let availableServices = sectionPreview.services?.map((service) => {
      const disabledPartConfigIds =
        service.excluded_service_section_part_config_ids || []
      const enabledServiceSectionPartConfigs = reject(
        sectionPreview.service_section_part_configs,
        (config) => {
          return contains(disabledPartConfigIds, config.id)
        }
      )

      return (
        <ServiceRow
          key={service.id}
          service={service}
          serviceSectionPartConfigs={enabledServiceSectionPartConfigs}
          orderingEnabled={true}
          onShowModal={onServiceClick}
        />
      )
    })

    return (
      <Fragment key={sectionPreview.id}>
        <div className={style.headingContainer}>
          <div className={style.copyContainer}>
            <h3 id={ALL_CATEGORIES} className={style.title}>
              {/* {I18n.t("service_ordering.all_categories")} */}
              {sectionPreview.title}
            </h3>

            <p className={style.subtitle}>
              {I18n.t("service_ordering.search_results_title_count", {
                count:
                  sections.find((section) => section.id === sectionPreview.id)
                    ?.services_count || 0,
              })}
            </p>
          </div>
        </div>
        <div className={style.servicesContainer}>
          {availableServices}
          <div
            className={style.showMoreContainer}
            onClick={() => handleShowAll(sectionPreview)}
          >
            <div className={style.showMoreInner}>
              <i className={`fal fa-plus-circle ${style.showMorePlus}`}></i>
              <p className={style.showAllTitle}>
                {I18n.t("service_ordering.all_categories_show_all")}
              </p>
            </div>
          </div>
          <div className={style.lastCard}></div>
          <div className={style.lastCard}></div>
        </div>
      </Fragment>
    )
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // GUARD
  if (sectionsPreview.length === 0) {
    return <div></div>
  }

  // -------------------------------------

  return (
    <Fragment>
      {sectionsPreview.map((sectionPreview) => {
        return renderSectionPreview(sectionPreview)
      })}
    </Fragment>
  )
}

// ----------------------------------------------------------------------------

export default ServicesSectionsPreview
